import { CustomTableSortItems } from 'commons/components/table/sort/custom-table-sorting.model';
import { sortByStringField } from 'commons/utils/sort.utils';
import { TenantUserRow } from './settings-user-location-assignment.vm';

// The tenant-users endpoint exposes no sort parameter, so ordering is applied client-side over the
// full list (TDR-018 §11.6: a tenant holds tens to a few hundred users).
export const sortTenantUsers = (users: TenantUserRow[], sortItems: CustomTableSortItems): TenantUserRow[] =>
    sortByStringField(users, sortItems, 'displayName');
